import {
  GSTR3B_REPORT_REQUEST,
  GSTR3B_REPORT_SUCCESS,
  GSTR3B_REPORT_FAILURE,
} from "../types/gstr3b-report-types";

const initialState = {
  gstr3bReport: {},
  loading: false,
  error: null,
};

const gstr3bReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GSTR3B_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GSTR3B_REPORT_SUCCESS: {
      return {
        ...state,
        gstr3bReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GSTR3B_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default gstr3bReportReducer;
